import COLORS from '@web-ui-kit/colors'
import SPACES from '@web-ui-kit/spaces'
import { styled } from 'styled-components'

export const Container = styled.footer`
  align-items: center;
  background-color: ${COLORS.WHITE};
  border-top: 0.0625rem solid ${COLORS.NEUTRAL_300};
  bottom: 0;
  box-sizing: border-box;
  display: flex;
  gap: ${SPACES.M};
  grid-area: footer;
  height: 3.5rem;
  justify-content: center;
  padding: 0 ${SPACES.L};
  position: fixed;
  width: 100%;
  z-index: 5;
`
